import { ColumnsMeta } from 'src/pages/SignInPage/_BLL/types';
import { SelectedColumn } from '../../customizeColumns/types';

const INITIAL_COLUMNS_IDS = [1000014, 1000016, 1000017, 1000019, 1000204, 10400001, 10401001, 10406001, 10405001];

export const generateInitialSearchResultColumns = (columnsMeta: ColumnsMeta) => {
	const initialColumns: SelectedColumn[] = [];

	for (const dataPointId of INITIAL_COLUMNS_IDS) {
		const column = columnsMeta.dataPoints[dataPointId];
		initialColumns.push({
			...column,
			reportingPeriodId: null,
			associatedDataTakenFromCompany: false,
			tableHeaderName: column.displayName,
		});
	}

	return initialColumns;
};
